import { render, staticRenderFns } from "./dirLeadGroupView.vue?vue&type=template&id=4d666b71&"
import script from "./dirLeadGroupView.vue?vue&type=script&lang=js&"
export * from "./dirLeadGroupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports